import { render } from "./Contact.html?vue&type=template&id=813e9b5c&scoped=true&ts=true&external"
import script from "./Contact.ts?vue&type=script&lang=ts&external"
export * from "./Contact.ts?vue&type=script&lang=ts&external"

import "./Contact.css?vue&type=style&index=0&id=813e9b5c&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-813e9b5c"]])

export default __exports__